import { canvasLabelMeasurer } from '@ardoq/graph-labeling';
import { Bounds } from '@ardoq/graph';
import {
  BLOCKS_VIEW_GROUP_BADGE_FONT,
  BLOCKS_VIEW_NODE_PAD,
  INVALID_RECTANGLE_SIDES,
} from '../../consts';
import type { BlocksViewNode } from '../../types';

const DESCENDANT_COUNT_BADGE_PADDING = 6;
const DESCENDANT_COUNT_BADGE_HEIGHT = 20;

const measureBadgeLabel = canvasLabelMeasurer(BLOCKS_VIEW_GROUP_BADGE_FONT);

const descendantCountBadgeRect = (
  node: BlocksViewNode,
  cell = node.cell
): Bounds => {
  const { children } = node;
  if (!children?.length || !cell) {
    return INVALID_RECTANGLE_SIDES;
  }
  const badgeLabelWidth = measureBadgeLabel(`${node.descendantCount}`);
  const badgeWidth = badgeLabelWidth + 2 * DESCENDANT_COUNT_BADGE_PADDING;
  const [, top, right] = cell;
  return [
    right - BLOCKS_VIEW_NODE_PAD - badgeWidth,
    top + BLOCKS_VIEW_NODE_PAD,
    right - BLOCKS_VIEW_NODE_PAD,
    top + BLOCKS_VIEW_NODE_PAD + DESCENDANT_COUNT_BADGE_HEIGHT,
  ];
};

export { descendantCountBadgeRect };
